(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      // Disable all sticky behavior completely
      this.style.position = 'static';
    }

    connectedCallback() {
      // Ensure the header never becomes sticky
      this.header = document.querySelector('.section-header');
      if (this.header) {
        this.header.classList.remove(
          'shopify-section-header-sticky',
          'shopify-section-header-hidden',
          'animate',
          'scrolled-past-header'
        );
        this.header.style.position = 'static';
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
